import React, { useState, useEffect } from "react";
import { db } from '../firebase/firestore';
import { collection, getDocs } from "firebase/firestore";

const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqs, setFaqs] = useState([]);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const snapshot = await getDocs(collection(db, "faq"));
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setFaqs(data);
      } catch (err) {
        console.error("Ошибка загрузки FAQ:", err);
      }
    };
    fetchFaqs();
  }, []);

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center">Frequently Asked Questions</h1>
      <div className="space-y-4">
        {faqs.length ? faqs.map((faq, index) => (
          <div key={faq.id} className="border border-gray-300 rounded-2xl shadow-sm">
            <button
              className="w-full flex justify-between items-center p-4 text-left font-medium text-lg"
              onClick={() => toggle(index)}
            >
              {faq.question}
              <span>{openIndex === index ? "−" : "+"}</span>
            </button>
            {openIndex === index && (
              <div className="p-4 pt-0 text-gray-600">{faq.answer}</div>
            )}
          </div>
        )) : <p className="text-gray-500">No FAQs available</p>}
      </div>
    </div>
  );
};

export default FaqPage;
